import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box } from 'grommet';
import { useAppTheme } from '@Components/Context';
import {
  Seo,
  InfoNotice,
} from '@Components/Control';
import { withProductAuth } from '@Components/Layout';
import { AuthNavWrapper } from '@Components/Navigation';
import { AllowlistTablePartial } from '@Components/Partial/Product/ContentId';
import {
  initiateFetchAllowlistRequest,
  clearContentIdAllowlistRequest,
  addContentIdAllowlistChannelRequest,
  updateContentIdAllowlistChannelRequest,
  deleteContentIdAllowlistChannelRequest,
} from '@Actions';


const AllowlistPage = ({
  small,
  loading,
  location,
  fetchAllowlistData,
  clearAllowlistData,
  addChannel,
  updateChannel,
  deleteChannel,
  paymentPending,
  allowlistData = null,
}) => {
  const { theme: { page }, isDarkMode } = useAppTheme();

  React.useEffect(() => {
    fetchAllowlistData();

    return () => {
      clearAllowlistData();
    };
  }, []);

  const handleAddChannel = async (body) => {
    if (paymentPending) return;
    await addChannel(body);
  };

  const handleUpdateChannel = async (body) => {
    if (paymentPending) return;
    await updateChannel(body);
  };

  const handleDeleteChannel = async (channelId) => {
    if (paymentPending) return;
    await deleteChannel(channelId);
  };

  const usePageBg = isDarkMode ? page.background : page.altBg;

  return (
    <AuthNavWrapper
      small={small}
      location={location}
      bannerProps={{
        title: 'Channel allowlist',
        subTitle: 'Content ID',
      }}
    >
      <Seo />
      <Box flex background={usePageBg} pad={{ vertical: '1.5rem' }} gap="1rem">
        <InfoNotice
          header="Managing your allowlist"
          text="Any YouTube channels added to your allowlist will be exempt from Content ID claims made using your reference files."
        />
        <AllowlistTablePartial
          small={small}
          allowlistData={allowlistData}
          onAddChannel={handleAddChannel}
          onUpdateChannel={handleUpdateChannel}
          onDeleteChannel={handleDeleteChannel}
          loading={loading}
          paymentPending={paymentPending}
        />
      </Box>
    </AuthNavWrapper>
  );
};

function mapStateToProps(state) {
  return {
    allowlistData: state.contentIdAllowlist.allowlist,
    loading: state.fetchLoader.dataLoading || state.fetchLoader.submissionLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAllowlistData: initiateFetchAllowlistRequest,
    clearAllowlistData: clearContentIdAllowlistRequest,
    addChannel: addContentIdAllowlistChannelRequest,
    updateChannel: updateContentIdAllowlistChannelRequest,
    deleteChannel: deleteContentIdAllowlistChannelRequest,
  }, dispatch);
}

AllowlistPage.propTypes = {
  small: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  fetchAllowlistData: PropTypes.func.isRequired,
  clearAllowlistData: PropTypes.func.isRequired,
  addChannel: PropTypes.func.isRequired,
  updateChannel: PropTypes.func.isRequired,
  deleteChannel: PropTypes.func.isRequired,
  allowlistData: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      kind: PropTypes.string,
      title: PropTypes.string,
    })),
    pageInfo: PropTypes.shape({
      totalResults: PropTypes.number.isRequired,
      resultsPerPage: PropTypes.number,
    }),
  }),
  paymentPending: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductAuth(AllowlistPage));

